var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollegeFair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Events hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Notification_Universities-",
    transform: "translate(-931.000000, -732.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(895.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Events-hover",
    transform: "translate(36.000000, 666.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EBF9FF",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(8.000000, 12.000000)",
    fill: "#007BE2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.172973,0 L2.58378378,0 C1.15675676,0 0,1.37364865 0,3.06824324 L0,21.5804054 C0,23.275 1.15675676,24.6486486 2.58378378,24.6486486 L18.172973,24.6486486 C19.6,24.6486486 20.7567568,23.275 20.7567568,21.5804054 L20.7567568,3.06824324 C20.7567568,1.37364865 19.6,0 18.172973,0 Z M28.4108108,2.41993243 L22.4864865,7.27263514 L22.4864865,17.3760135 L28.4108108,22.2222973 C29.5567568,23.1594595 31.1351351,22.2030405 31.1351351,20.5662162 L31.1351351,4.07601351 C31.1351351,2.44560811 29.5621622,1.48277027 28.4108108,2.41993243 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeFair);
export default __webpack_public_path__ + "static/media/college_fair.a7bc94227c2096d45863640444ceff6b.svg";
export { ForwardRef as ReactComponent };